import styled from "styled-components"

const StyledStepThird = styled.div`
  .order-boxes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
    .order-courier-form__info {
      flex-basis: 55%;
      max-width: 55%;
    }
    .order-box {
      flex-basis: 414px;
      max-width: 414px;
      border: 2px solid #000;
      padding: 50px;
      position: relative;
      .inp-error {
        display: none;
      }
      &__wrapper {
        display: flex;
        align-items: flex-start;
        .box-icon {
          flex-basis: 80px;
          max-width: 80px;
        }
        .box-form {
          flex: 1;
          &__label {
            font-size: 24px;
            line-height: 32px;
          }
        }
      }
    }
    @media screen and (max-width: 1300px) {
      .order-courier-form__info {
        flex-basis: calc(50% - 20px);
        max-width: calc(50% - 20px);
      }
      .order-box {
        flex-basis: calc(50% - 20px);
        max-width: calc(50% - 20px);
        &__wrapper {
          .box-form {
            &__label {
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 900px) {
      .order-courier-form__info,
      .order-box {
        flex-basis: 100%;
        max-width: 100%;
      }
      .order-box {
        margin-top: 60px;
        &__wrapper {
          .box-form {
            &__label {
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 600px) {
      .order-box {
        &__wrapper {
          position: relative;
          .box-icon {
            position: absolute;
            flex-basis: 60px;
            max-width: 60px;
            top: 0;
            left: 0;
            svg {
              max-width: 37px;
            }
          }
          .box-form {
            &__label {
              padding: 14px 0 0 60px;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 420px) {
      .order-box {
        &__wrapper {
          .box-form {
            &__label {
              max-width: 250px;
              padding: 5px 0 0 60px;
            }
          }
        }
      }
    }
  }
`

export default StyledStepThird
